import { Component, Input, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { DrawerComponent } from "../../drawer/drawer.component";
import { GenericDrawerService } from "../../drawer/global-drawer.service";
import { FilesManagerService } from "../files-manager.service";
import { HotToastService } from "@ngneat/hot-toast";

declare var SignWellEmbed: any;

@Component({
    selector: "app-sign-preview",
    templateUrl: "./sign-preview.component.html",
    styleUrls: ["./sign-preview.component.css"],
    standalone: true,
})
export class SignPreviewComponent implements OnInit {
  @Input() mode: string = "";
  @Input() signRequest: any;

  constructor(private genericDrawerService: GenericDrawerService) {}

  ngOnInit() {
    this.openSignWellFrame();
  }

  openSignWellFrame() {
    let signWellEmbed = new SignWellEmbed({
      url:
        this.signRequest.document.embedded_edit_url ??
        this.signRequest.document.embedded_preview_url,
      containerId: "iframe",
      showHeader: true,
      allowClose: false,
      events: {
        completed: (e) => {
          console.log("signwell: completed event: ", e);
          this.genericDrawerService.closeDrawer$.next(null);
        },
        closed: (e) => {
          console.log("signwell: closed event: ", e);
          this.genericDrawerService.closeDrawer$.next(null);
        },
      },
    });
    signWellEmbed.open();
  }
}
